import axios from 'axios';
const base = 'novedades';

function getAll(query = null) {
    return axios.get(base, {
        params: query
    });
}

function register(data) {
    return axios.post(base, data);
}

function update(data) {
    return axios.put([base, data.id_nov].join('/'), data);
}

function destroy(id) {
    return axios.delete([base, id].join('/'));
}

const NovedadesService = {
    getAll,
    register,
    update,
    destroy,
};
export default NovedadesService;